export default class Locale_ResourceEditor { 
	HasUnsavedChanges: string = "Resource has unsaved changes";
	IgnoreChanges: string = "Do you want to ignore these changes?";
	ResourceOverview: string = "Resource editor";
}